export const PLUGIN_KITE = 'plugins/kite';
export const STALE_TIME = 1000 * 60; // 1 minute
